import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const OrderConversionListSummaryStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  marginBottom: '24px',
  paddingTop: '16px',
});
